import React from 'react'
import { Badge, Card, Table } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const ReactActivityTable = ({ incidents}) => {
  return (
    <Card className='border-0 shadow-sm mt-4'>
        <Card.Header className='bg-white border-0 py-3'>
            <h5 className="mb-0 fw-bold text-dark">Recent Incident Reports</h5>
        </Card.Header>
        <Card.Body className='p-0'>
            <Table responsive hover className='mb-0'>
                <thead className='bg-light'>
                    <tr>
                        <th className='ps-4'>Date</th>
                        <th>Site</th>
                        <th>Type</th>
                        <th>Status</th>
                        <th>View Details</th>
                    </tr>
                </thead>
                <tbody>
                    {incidents && incidents.length > 0 ? 
                        (
                            incidents.map((incident) => (
                                <tr key={incident.id} className='align-middle'>
                                    <td className='ps-4'>
                                        {new Date(incident.created_at).toLocaleDateString()}
                                    </td>
                                    <td className='fw-semibold'>{incident.duty_log?.schedule?.site?.name || 'N/A'}</td>
                                    <td>
                                        <Badge bg='secondary' className='bg-opacity-10 text-dark border'>
                                            {incident.type}
                                        </Badge>
                                    </td>
                                    <td>
                                        {/** New Status Badge */}
                                        <Badge
                                            bg={incident.status === 'pending' ? 'warning' : 'success'}
                                            className='text-capitalize'
                                        >
                                            {incident.status.replace('_', '')}
                                        </Badge>
                                    </td>
                                    <td className='text-end pe-4'>
                                        <Link to={`/incidents/${incident.id}`} className='btn btn-sm btn-outline-primary'>
                                            View Details
                                        </Link>
                                    </td>
                                </tr>
                            ))
                        ) : 
                        (
                            <tr>
                                <td colSpan="4" className='text-center py-4 text-muted'>
                                    No recent incidents recorded.
                                </td>
                            </tr>
                        )
                    }
                </tbody>
            </Table>
        </Card.Body>
    </Card>
  )
}

export default ReactActivityTable